import {
  faChevronDown,
  faChevronUp,
  faHandHolding,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Checkbox, Input, Modal } from "@mantine/core";
import _, { sample } from "lodash";
import { useEffect, useState } from "react";
import { statesData } from "../json/StatesData";
import B2BButton from "../../common/B2BButton";
import { FaInfoCircle } from "react-icons/fa";
const ProceedCart = ({
  items,
  profile,
  loyalty,
  sampleCart,
  wholesaleCart,
  sampleSelected,
  loading,
  wholesaleSelected,
  isToggled,
  handleToggle,
  getStateValue,
  handleProceed,
  price,
  swatchCart,
  swatchSelected,
  comboCart,
  comboSelected,
  uom
}) => {
  console.log(wholesaleSelected, "items in proceed cart");
  const [selectCheckBox, setSelectCheckBox] = useState(false);
  const [isSecondModalOpen, setIsSecondModalOpen] = useState(false);
  const [cityOptions, setCityOptions] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [errors, setErrors] = useState({});
  const [loyaltyModalOpen, setLoyaltyModalOpen] = useState(false);
  const [formAddressData, setFormAddressData] = useState({
    nickName: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    pincode: "",
    country: "",
    mobileNo: "",
    email: "",
  });


  const closeSecondModal = () => {
    setIsSecondModalOpen(false);
    setIsEditMode(false);
    setFormAddressData({
      address1: "",
      address2: "",
      city: "",
      state: "",
      pincode: "",
      country: "",
      mobileNo: "",
      email: "",
    });
  };
  const handleEdit = (addr) => {
    setFormAddressData(addr);
    setIsEditMode(true);
    openSecondModal();
  };
  const openSecondModal = () => setIsSecondModalOpen(true);
  const handleStateChange = (event) => {
    const selectedState = event.target.value;
    const stateData = statesData.find((state) => state.name === selectedState);
    setFormAddressData({ ...formAddressData, state: selectedState, city: "" });
    setCityOptions(stateData ? stateData.districts : []);
  };

  const handleCityChange = (e) => {
    const selectedCity = e.target.value;
    setFormAddressData((prev) => ({ ...prev, city: selectedCity }));
  };

  useEffect(() => {
    const stateData = statesData.find(
      (state) => state.name === formAddressData.state
    );
    setCityOptions(stateData ? stateData.districts : []);
  }, [formAddressData.state]);

  useEffect(() => {
    if (
      !loading &&
      swatchCart &&
      profile &&
      loyalty &&
      swatchSelected?.length > 0 &&
      loyaltycondition
    ) {
      setLoyaltyModalOpen(true);
    }
  }, [loading, swatchCart, profile, loyalty, swatchSelected]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormAddressData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };
  let lengthAll = false;

  if (wholesaleCart) {
    lengthAll = wholesaleSelected.length < 1 && comboSelected.length < 1;
  } else if (sampleCart) {
    lengthAll = sampleSelected.length < 1;
  } else if (swatchCart) {
    lengthAll = swatchSelected.length < 1;
  }
  const handleSave = async () => {
    if (!validateAddress()) return;
    try {
      const res = await B2B_API.post(`customer/location`, {

        json: formAddressData,
      });
      fetchAllAddresses();
      closeSecondModal();
    } catch (error) {
      console.error("Error on adding address:", error);
    }
  };


  const swatchamt = _.sumBy(
    swatchSelected,
    (item) =>
      item.sellingPrice *
      item.quantity
  );
  const wholesaleSum = _.sumBy(
    wholesaleSelected,
    (item) => {
      const main = item.sellingPrice * item.quantity
      const rib = item?.ribItem ? item?.ribItem?.quantity * item?.ribItem?.sellingPrice : 0;
      return main + rib
    }
  );

  const typeOfSupplyCheck = _.some(
    wholesaleSelected,
    (item) => item.typeOfSupply === "OrderDriven"
  );

  const orderDrivenItems = _.filter(
    wholesaleSelected,
    (item) => item.typeOfSupply === "OrderDriven"
  );

  const isAnyArticleLessThanMOQ = _.every(
    orderDrivenItems,
    (item) => item.quantity >= (item.moqtypeSupply || 0)
  );
  const comboSum = _.sumBy(
    comboSelected,
    ({ combo, variants }) => {
      const main = combo.sellingPrice * combo.quantity * variants.length;

      const ribTotal = _.sumBy(variants, (variant) => {
        const rib = variant.ribItem;
        if (rib && rib.sellingPrice && rib.quantity) {
          return rib.sellingPrice * rib.quantity;
        }
        return 0;
      });

      return main + ribTotal
    }
  );

  const allVariantUoms = Object.values(items)
    .flat()
    .map(item => uom[item.variantSku])
    .filter(Boolean);


  const uniqueUoms = [...new Set(allVariantUoms)];
  console.log(uniqueUoms, "uniqueUoms")
  let uomDisplay = '';
  if (uniqueUoms.length === 0) {
    uomDisplay = '';
  } else if (uniqueUoms.length === 1) {
    uomDisplay = uniqueUoms[0];
  } else {
    const allButLast = uniqueUoms.slice(0, -1).join(', ');
    uomDisplay = `(${allButLast},${uniqueUoms[uniqueUoms.length - 1]})`;
  }

  const message = `Ordered ${swatchCart ? "pcs" : uomDisplay} and Actual ${swatchCart ? "pcs" : uomDisplay} may varies, Click here to Proceed Cart`;



  const loyaltycondition = (swatchCart && swatchamt < loyalty?.minRedeemPoints || profile?.loyaltyAmount < swatchamt || profile?.loyaltyPoints < swatchamt || (!profile?.loyaltyAmount || profile?.loyaltyId === null));

  const wholesaleTotal = (wholesaleSum + comboSum).toFixed(2);
  const wholesaleCount = _.size(wholesaleSelected) + _.size(comboSelected);
  const subtotall = _.reduce(items, (sum, item) => {
    if (item.combo) {
      // combo: (qty × #variants) × sellingPrice
      const qty = item.combo.quantity * (item.variants?.length || 0);
      const unitPrice = Number(item.combo.sellingPrice) || 0;
      return sum + qty * unitPrice;
    } else {

      const unitPrice = item.sellingPrice;
      return sum + unitPrice * (item.quantity || 0);
    }
  }, 0);
  return (
    <>
      <Modal
        size="lg"
        styles={{ content: { "--modal-y-offset": "12dvh" } }}
        centered
        opened={isSecondModalOpen}
        onClose={closeSecondModal}
        title={
          <div style={{ fontWeight: "600", fontSize: "20px" }}>
            {isEditMode ? "Edit Address" : "New Address"}
          </div>
        }
      >
        <div className="edit-body">
          <div className="form-address">
            <div className="form-control required field-nickname">
              <label className="flex-row items-center m-b-4 asterisk">
                <span className="flex-wrap">Address Nickname</span>
              </label>
              <div className="c-danger f-12 f-500 m-b-8">
                Please do not use a PO Box for your delivery address.
              </div>
              <Input
                name="nickName"
                value={formAddressData.nickName}
                error={errors.nickName}
                onChange={handleInputChange}
              />
            </div>

            <div className="form-control required">
              <label className="display-block asterisk">Country</label>
              <Input
                name="country"
                value={formAddressData.country}
                error={errors.country}
                onChange={handleInputChange}
              />
            </div>

            <div className="address-hr"></div>

            <div className="form-control required field-street-1">
              <label className="flex-row items-center asterisk">
                <span className="flex-wrap"> Street 1</span>
              </label>
              <Input
                name="address1"
                value={formAddressData.address1}
                error={errors.address1}
                onChange={handleInputChange}
              />
            </div>

            <div className="form-control field-street-2">
              <label className="flex-row items-center asterisk">
                <span className="flex-wrap"> Street 2</span>
              </label>
              <Input
                name="address2"
                value={formAddressData.address2}
                error={errors.address2}
                onChange={handleInputChange}
              />
            </div>

            <div className="sub-destination">
              <div className="sub-destination">
                <div className="form-control flex-fill m-b-0 required">
                  <label className="display-block asterisk">State</label>
                  <select
                    name="state"
                    value={formAddressData.state}
                    onChange={handleStateChange}
                  >
                    <option value="">Select State</option>
                    {statesData.map((state) => (
                      <option key={state.name} value={state.name}>
                        {state.name}
                      </option>
                    ))}
                  </select>
                  {errors.state && <div className="error">{errors.state}</div>}
                </div>

                <div className="form-control flex-fill m-b-0 required">
                  <label className="display-block asterisk">City</label>
                  <select
                    name="city"
                    value={formAddressData.city}
                    onChange={handleCityChange}
                    disabled={!cityOptions.length}
                  >
                    <option value="">Select City</option>
                    {cityOptions.map((city) => (
                      <option key={city} value={city}>
                        {city}
                      </option>
                    ))}
                  </select>
                  {errors.city && <div className="error">{errors.city}</div>}
                </div>
              </div>
            </div>

            <div className="form-control required field-postal-code">
              <label className="flex-row items-center asterisk">
                <span className="flex-wrap">Postal Code</span>
              </label>
              <Input
                name="pincode"
                value={formAddressData.pincode}
                error={errors.pincode}
                onChange={handleInputChange}
              />
            </div>

            <div className="address-hr"></div>

            <div className="input-phone form-control required field-phone">
              <label className="asterisk">Contact Phone</label>
              <Input
                name="mobileNo"
                value={formAddressData.mobileNo}
                error={errors.mobileNo}
                onChange={handleInputChange}
              />
            </div>

            <div className="form-control required field-recipient-email">
              <label className="flex-row items-center asterisk">
                <span className="flex-wrap">Contact Email</span>
              </label>
              <Input
                name="email"
                value={formAddressData.email}
                error={errors.email}
                onChange={handleInputChange}
              />
            </div>

            <div className="bottom-buttons">
              <button className="btns btn-default" onClick={closeSecondModal}>
                Cancel
              </button>
              <button className="btns btn-primary" onClick={handleSave}>
                Save
              </button>
            </div>
          </div>
        </div>
      </Modal>

      <div className="second required">
        <div
          className="conditional-sticky"
          style={{
            top: "calc(16px + var(--app-header-height))",
            position: "sticky",
            zIndex: "2",
          }}
        >
          <div className="ultron-box-price-summary cart-price-summary card-price-summary">
            <div className="header">
              {sampleCart
                ? "Sample Cart"
                : wholesaleCart
                  ? "Wholesale Cart"
                  : swatchCart
                    ? "Swatch Cart"
                    : comboCart
                      ? "Wholesale Cart"
                      : ""}
            </div>
            <div className="subtotal-explanation">
              {swatchCart && (<div> <div className="row">
                <div className="key">Loyalty points :</div>
                <div className="value">{profile?.loyaltyAmount ? profile?.loyaltyAmount : 0} points</div>
              </div>
                {(loyalty?.minRedeemPoints || 0) > 0 && <div className="row">
                  <div className="key">Minimum redeem points :</div>
                  <div className="value">{loyalty?.minRedeemPoints || 0} points </div>
                </div>}</div>)}
              <div className="row">
                <div className="key">
                  Subtotal (
                  {sampleCart
                    ? _.size(sampleSelected)
                    : wholesaleCart
                      ? wholesaleCount
                      : swatchCart
                        ? _.size(swatchSelected)
                        : comboCart
                          ? _.size(comboSelected)
                          : 0}{" "}
                  {(() => {
                    const count =
                      sampleCart
                        ? _.size(sampleSelected)
                        : wholesaleCart
                          ? wholesaleCount
                          : swatchCart
                            ? _.size(swatchSelected)
                            : comboCart
                              ? _.size(comboSelected)
                              : 0;

                    return count <= 1 ? 'Product' : 'Products';
                  })()}
                  )
                </div>

                <div className="value">
                  {`${!swatchCart ? "₹" : ""} ${sampleCart
                    ? _.sumBy(
                      sampleSelected,
                      (item) =>
                        (item?.sellingPrice) *
                        item.quantity
                    ).toFixed(2)
                    : wholesaleCart
                      ? wholesaleTotal
                      : swatchCart
                        ? _.sumBy(
                          swatchSelected,
                          (item) =>
                            item.sellingPrice *
                            item.quantity
                        ).toFixed(2)
                        : comboCart
                          ? _.sumBy(
                            comboSelected,
                            (item) =>
                              item.combo.sellingPrice *
                              item.combo.quantity *
                              item?.variants?.length
                          ).toFixed(2)
                          : "0.00"
                    } ${swatchCart ? "points" : ""}`}
                </div>
              </div>

              {swatchCart && (
                <div className="row">

                  <div className="key">    <div style={{ fontSize: "12px", color: "#888" }}>
                    ( Loyalty Points - Subtotal )
                  </div>Remaining Loyalty points :</div>
                  <div className="value">
                    {(
                      (profile?.loyaltyAmount || 0) -
                      (
                        sampleCart
                          ? _.sumBy(sampleSelected, (item) => item?.sellingPrice * item.quantity)
                          : wholesaleCart
                            ? wholesaleTotal
                            : swatchCart
                              ? _.sumBy(swatchSelected, (item) => item.sellingPrice * item.quantity)
                              : comboCart
                                ? _.sumBy(
                                  comboSelected,
                                  (item) =>
                                    item.combo.sellingPrice *
                                    item.combo.quantity *
                                    item?.variants?.length
                                )
                                : 0
                      )
                    ).toFixed(2)}{" "}
                    points
                  </div>
                </div>
              )}
              <div className="shipping-fee row">
                {/* <div className="key flex-row">Shipping</div> */}
                {/* <div className="value">12</div> */}
              </div>
            </div>

            <div className="total">
              {/* {swatchCart  && swatchSelected?.length > 0 && (
                <div className="total">
                     {profile?.loyaltyAmount > swatchamt ? (<div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", color: "gray" }}>

                    <div style={{ display: "flex", flexDirection: "column" }}> {swatchamt < loyalty?.minRedeemPoints && (<span style={{ fontSize: "12px", color: "red" }}>
                      Subtotal points should more than or equal to min redeem points</span>)}
                    {swatchamt >= loyalty?.minRedeemPoints && (  <span style={{ fontSize: "12px", display: "flex", justifyContent: "flex-end" }}>
                        subtotal {swatchamt.toFixed(2)} reduced from loyalty {profile?.loyaltyAmount.toFixed(2)}</span> )}</div></div>
                  ) : (<div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", color: "red" }}><span style={{ fontSize: "12px" }}>
                    Not enough loyalty points to place order</span> </div>)}
                </div>)} */}
              <div className="row">
                <div className="key">Total</div>
                <div className="value">
                  {`${!swatchCart ? "₹" : ""} ${sampleCart
                    ? _.sumBy(
                      sampleSelected,
                      (item) =>
                        item?.sellingPrice *
                        item?.quantity
                    ).toFixed(2)

                    : wholesaleCart
                      ? wholesaleTotal
                      : swatchCart
                        ? _.sumBy(

                          swatchSelected,
                          (item) =>
                            item.sellingPrice *
                            item.quantity
                        ).toFixed(2)
                        : comboCart
                          ? _.sumBy(
                            comboSelected,
                            (item) =>
                              item.combo.sellingPrice *
                              item.combo.quantity *
                              item?.variants?.length
                          ).toFixed(2)
                          : "0.00"
                    } ${swatchCart ? "points" : ""}`}
                </div>
              </div>
            </div>
            {/* <div className="estimated-delivery">
              <div className="label">
                <FontAwesomeIcon className='i' icon={faHandHolding} />
                Estimated Delivery
              </div>
              <div className="value">Aug 20, 2024</div>
                checked={selectCheckBox}
                onChange={() => setSelectCheckBox((prev) => !prev)}
            </div> */}
          </div>
          <div className="agreement">
            <div className="checkout-optional-sections">
              <div className="checkout-section-box m-b-0">
                <div style={{ display: 'flex', flexDirection: "row" }}>
                  <div style={{ display: 'flex', alignItems: "center" }}>
                    <Checkbox
                      checked={selectCheckBox}
                      onChange={() => setSelectCheckBox((prev) => !prev)}
                    />
                  </div>
                  <div style={{ marginLeft: "10px", fontWeight: "bold" }}>{message}</div></div>
                {selectCheckBox && wholesaleCart && typeOfSupplyCheck && (
                  <div style={{ fontSize: "12px", color: "red" }}>
                    <span style={{ color: "gray" }}>NOTE:</span>{" "}Minimum qty must be greater than or equal to{" "}
                    {wholesaleSelected[0]?.moqtypeSupply} for Made To Order.

                  </div>
                )}

              </div>
              {selectCheckBox && (
                <div className="flex g-8">
                  <B2BButton
                    name={"Proceed to cart"}
                    color={"#8BC53F"}
                    disabled={swatchCart && loyaltycondition || lengthAll || (wholesaleCart && !isAnyArticleLessThanMOQ && typeOfSupplyCheck)}
                    onClick={() => {
                      handleProceed();
                    }}
                    style={{
                      fontWeight: 600,
                      height: "48px",
                      boxShadow: "0 3px 6px 0 rgba(0,0,0,.16)",
                    }}
                  >
                    Proceed to cart
                  </B2BButton>
                </div>
              )}
            </div>
          </div>
          {wholesaleCart && (
            <div className="estimated-ultron-point-to-earn text-center">
              {/* <span>You'll earn <span className="f-600 c-primary">52 ultron Points!</span></span> */}
              {/* <FontAwesomeIcon icon={faHandHolding} className="cursor-pointer m-l-8 i" /> */}
            </div>
          )}
          <Modal
            centered
            opened={loyaltyModalOpen}
            onClose={() => setLoyaltyModalOpen(false)}
            title={<div style={{ fontWeight: 600 }}>Loyalty Points Required</div>}
          >
            <div style={{ fontSize: "14px", color: "#444" }}>
              You don’t have enough loyalty points to proceed with this order.
            </div>
            <div style={{ display: "flex", justifyContent: "center", marginTop: "1rem" }}>
              <Button
                color="#8BC53F"
                onClick={() => setLoyaltyModalOpen(false)}
              >
                OK
              </Button>
            </div>
          </Modal>
          <div className="cart-optional-sections"></div>
        </div>
      </div >


    </>

  );

};


export default ProceedCart;
